import {
  Component,
  ElementRef,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common/common.service';

declare var require: any;
var CryptoJS = require('crypto-js');

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  form_data: any = {
    // role: '',
    role: 5,
    email: '',
    password: '',
  };

  form_data_errors: any = {
    role: false,
    email: false,
    password: false,
  };

  globalError: boolean = false;
  accountNotExistError: boolean = false;
  roleNotExistError: boolean = false;
  login_loading_state: boolean = false;

  password_active: boolean = true;


  constructor(
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
    public commonService:CommonService
  ) {}

  ngOnInit(): void {
    // this.authService.logout();
    this.getRoles();
  }

  roles_list: any = [];
  getRoles() {
    this.commonService.getData('/group?no_page=true/').subscribe(
      (res: any) => {
        this.roles_list = res;
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
  }

  show_otp_view: boolean = false;
  otp_value: any = "";
  otp_error: boolean = false;

  generateOTP() {
    this.otp_value = "";
    this.otp_error = false;

    this.login_loading_state = true;

    if (this.form_data.email != '' && this.form_data.email != null) {
      if (
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
          this.form_data.email,
        )
      ) {
        this.form_data_errors.email = false;
      } else {
        this.form_data_errors.email = true;
      }
    } else {
      this.form_data_errors.email = true;
    }

    if (this.form_data.password != '' && this.form_data.password != null) {
      this.form_data_errors.password = false;
    } else {
      this.form_data_errors.password = true;
    }

    if (this.form_data.role != '' && this.form_data.role != null) {
      this.form_data_errors.role = false;
    } else {
      this.form_data_errors.role = true;
    }

    if (
      this.form_data_errors.email == false &&
      this.form_data_errors.password == false &&
      this.form_data_errors.role == false
    ) {
      this.globalError = false;
      this.accountNotExistError = false;
      this.roleNotExistError = false;
      const payload = {
        email: this.form_data.email,
        password: this.encryptPassword(
          JSON.parse(JSON.stringify(this.form_data.password)),
        ),
        role: this.form_data.role,
      };

      this.commonService.postData("/otpauthentication/", payload).subscribe(
        (res) => {
          this.login_loading_state = false;
          this.show_otp_view = true;
          this.commonService.showToast('success', 'An OTP has been sent to given email address.');
        },
        (err) => {
          // Errors
          this.login_loading_state = false;
          if (err.error.status[0] == 'blocked') {
            this.openAccountDisabledModal();
          } else if (err.error.status[0] == 'update') {
            this.reset_password_link = err.error.link[0];
            this.openPasswordExpiryModal();
          } else if (err.error.status[0] == 'fail') {
            this.globalError = true;
          } else if (err.error.status[0] == 'Account does not exist') {
            this.accountNotExistError = true;
          } else if (err.error.status[0] == 'Selected role doesnot exist for this user') {
            this.roleNotExistError = true;
          }
        },
      );
    } else {
      this.login_loading_state = false;
    }

  }

  login() {
    console.log("inside")
    this.login_loading_state = true;

    if (this.form_data.email != '' && this.form_data.email != null) {
      if (
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
          this.form_data.email,
        )
      ) {
        this.form_data_errors.email = false;
      } else {
        this.form_data_errors.email = true;
      }
    } else {
      this.form_data_errors.email = true;
    }

    if (this.form_data.password != '' && this.form_data.password != null) {
      this.form_data_errors.password = false;
    } else {
      this.form_data_errors.password = true;
    }

    if (this.form_data.role != '' && this.form_data.role != null) {
      this.form_data_errors.role = false;
    } else {
      this.form_data_errors.role = true;
    }

    // if (this.otp_value != '' && this.otp_value != null) {
    //   this.otp_error = false;
    // } else {
    //   this.otp_error = true;
    // }

    if (
      this.form_data_errors.email == false &&
      this.form_data_errors.password == false &&
      this.form_data_errors.role == false
      // &&
      // this.otp_error == false
    ) {
      this.globalError = false;
      this.accountNotExistError = false;
      this.roleNotExistError = false;

      // this.otp_error = false;

      const payload = {
        email: this.form_data.email,
        password: this.encryptPassword(
          JSON.parse(JSON.stringify(this.form_data.password)),
        ),
        role: this.form_data.role,
        otp: this.otp_value
      };
      this.authService.loginWithEmailPassword(payload).subscribe(
        (result) => {
          this.login_loading_state = true;
          this.commonService.setBaseUrl();
          // Success
        },
        (err) => {
          // Errors
          this.login_loading_state = false;
          if (err.error.status[0] == 'blocked') {
            this.openAccountDisabledModal();
          } else if (err.error.status[0] == 'update') {
            this.reset_password_link = err.error.link[0];
            this.openPasswordExpiryModal();
          } else if (err.error.status[0] == 'fail') {
            this.globalError = true;
          } else if (err.error.status[0] == 'Account does not exist') {
            this.accountNotExistError = true;
          } else if (err.error.status[0] == 'Selected role doesnot exist for this user') {
            this.roleNotExistError = true;
          } else if (err.error.status[0] == 'OTP doesnt match') {
            this.otp_error = true;
          }
        },
      );
    } else {
      this.login_loading_state = false;
    }
  }

  encryptPassword(password: string): string {
    const ciphertext = CryptoJS.AES.encrypt(
      password,
      'WealthGrowth-Secret-Key',
    ).toString();
    return ciphertext;
  }

  navigate(url) {
    this.router.navigate([url]);
  }

  @ViewChild('accountDisabledModal') accountDisabledModal: TemplateRef<any>;
  private accountDisabledModalRef: MatDialogRef<TemplateRef<any>>;
  openAccountDisabledModal() {
    this.accountDisabledModalRef = this.dialog.open(this.accountDisabledModal, {
      disableClose: true,
    });
    this.accountDisabledModalRef.afterClosed().subscribe((result) => {
      this.closeAccountDisabledModal();
    });
  }

  closeAccountDisabledModal() {
    this.accountDisabledModalRef.close();
  }

  @ViewChild('passwordExpiryModal') passwordExpiryModal: TemplateRef<any>;
  private passwordExpiryModalRef: MatDialogRef<TemplateRef<any>>;
  openPasswordExpiryModal() {
    this.passwordExpiryModalRef = this.dialog.open(this.passwordExpiryModal, {
      disableClose: true,
    });
    this.passwordExpiryModalRef.afterClosed().subscribe((result) => {
      this.closePasswordExpiryModal();
    });
  }

  reset_password_link: any = '';
  closePasswordExpiryModal() {
    this.reset_password_link = '';
    this.passwordExpiryModalRef.close();
  }

  reset() {
    window.open(this.reset_password_link, '_self');
  }

  users: any = [];
  valueChanged(value) {
  }
}
